module.exports = __webpack_public_path__ + "img/integration.7170a4ed.svg";